import React, { useEffect, useState } from "react";
import { getServices } from "../../apiServices/apiServices";
import toast from "react-hot-toast";
import { LIST_BYPASS_TABLE_HEAD } from "../../variables/constants";
import { Card, Typography } from "@material-tailwind/react";
import NoDataFound from "../../components/NoDataFound";
import LoadingGif from "../../assets/loading_anim.gif";
import moment from "moment";
import dayjs from "dayjs";

// const getTodayDate = () => dayjs().subtract(1, "day").format("YYYY-MM-DD");
const getTodayDate = () => dayjs().format("YYYY-MM-DD");

function HeadBypassReport() {
  const [bypassList, setBypassList] = useState([]);
  const [loading, setLoading] = useState({
    screen: false,
  });
  const [filterData, setFilterData] = useState({
    date: getTodayDate(),
  });
  const access_token = localStorage.getItem("gassol-head-branch-token");

  useEffect(() => {
    fetchBypassList();
  }, [filterData]);

  const fetchBypassList = async () => {
    setLoading({ ...loading, screen: true });
    try {
      const res = await getServices(
        `/api/bypass/report?date=${filterData.date}`,
        access_token
      );
      setLoading({ ...loading, screen: false });

      if (res.responseCode === 200) {
        setBypassList(res.responseData);
      } else {
        setBypassList([]);
      }
    } catch (error) {
      setLoading({ ...loading, screen: false });
      toast.error(error);
    }
  };

  return (
    <>
      <div className="px-6 pb-5 flex flex-col gap-6 pt-4 lg:pt-0">
        <div className="flex justify-between items-center gap-3">
          <p className="text-xl sm:text-2xl md:text-5xl font-bold">
            Bypass Report
          </p>
          <div className="flex flex-col w-[250px]">
            <label className="font-semibold">Date: </label>
            <input
              name="filter_date"
              type="date"
              onKeyDown={(e) => e.preventDefault()}
              value={filterData.date}
              onChange={(e) =>
                setFilterData({
                  ...filterData,
                  date: e.target.value,
                })
              }
              max={getTodayDate()}
              className="bg-gray-200 px-3 py-2 rounded-md border border-gray-600 outline-none"
            />
          </div>
        </div>

        {!loading.screen ? (
          <>
            {bypassList.length > 0 ? (
              <Card
                className="h-full w-full rounded-none overflow-x-scroll md:overflow-x-hidden"
                style={{
                  boxShadow:
                    "0 4px 8px 0 rgba(0, 0, 0, 0), 0 6px 20px 0 rgba(0, 0, 0, 0.06)",
                }}
              >
                <table className="w-full min-w-max table-auto text-left">
                  <thead>
                    <tr>
                      {LIST_BYPASS_TABLE_HEAD.map((head) => (
                        <th
                          key={head}
                          className="border-b border-blue-gray-100 bg-[#03438D] p-4"
                        >
                          <Typography
                            variant="small"
                            color="blue-gray"
                            className="font-poppins text-white font-semibold uppercase"
                          >
                            {head}
                          </Typography>
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {Array.isArray(bypassList) && bypassList.length > 0 ? (
                      bypassList.map((bypass, index) => (
                        <tr key={index}>
                          <td className="p-4">
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="font-poppins font-semibold flex items-center gap-2"
                            >
                              {index + 1}.
                            </Typography>
                          </td>
                          <td className="p-4">
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="font-poppins font-semibold flex items-center gap-2"
                            >
                              {bypass.id ?? "-"}
                            </Typography>
                          </td>
                          <td className="p-4">
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="font-poppins font-semibold flex items-center gap-2"
                            >
                              {bypass.branch ?? "-"}
                            </Typography>
                          </td>
                          <td className="p-4">
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="font-poppins font-semibold flex items-center gap-2"
                            >
                              {bypass.phone ?? "-"}
                            </Typography>
                          </td>
                          <td className="p-4">
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="font-poppins font-semibold flex items-center gap-2"
                            >
                              {bypass.bypass_on
                                ? moment(bypass.bypass_on).format(
                                    "DD/MM/YYYY HH:mm"
                                  )
                                : "-"}
                            </Typography>
                          </td>
                          <td className="p-4">
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className={`font-poppins font-semibold flex items-center gap-2 ${
                                bypass.case_state === 1 ? "text-red-600" : ""
                              }`}
                            >
                              {bypass.case_state === 0
                                ? "Resolved"
                                : bypass.case_state === 1
                                ? "Bypassing"
                                : "-"}
                            </Typography>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="5">
                          <NoDataFound />
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </Card>
            ) : (
              <NoDataFound />
            )}
          </>
        ) : (
          <div className="w-full flex justify-center items-center h-[60vh]">
            <img src={LoadingGif} alt="" />
          </div>
        )}
      </div>
    </>
  );
}

export default HeadBypassReport;
